import React, { useState } from 'react';
import { hasWholeYear } from '../utils/dateUtils';

type DateInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'onChange' | 'onBlur'> & {
  type: 'date' | 'datetime-local';
  value: string;
  /** Gets the field's value once its year is whole, or '' when it's emptied */
  onChange: (value: string) => void;
};

/**
 * A date, or date and time, input. Browsers report a year as it's typed, and its first digit was saved as year 2 (or
 * 1902 for a show). So an incomplete year is kept as typed, and leaving the field puts the saved date back.
 */
const DateInput: React.FC<DateInputProps> = ({ value, onChange, ...props }) => {
  const [typed, setTyped] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value || hasWholeYear(e.target.value)) {
      setTyped(null);
      onChange(e.target.value);
    } else {
      setTyped(e.target.value);
    }
  };

  return <input {...props} value={typed ?? value} onChange={handleChange} onBlur={() => setTyped(null)} />;
};

export default DateInput;
